import axios from 'axios';
import { BASE_URL, ENDPOINTS } from './apiConfig';

/**
 * Get all leaves for the company
 * @returns {Promise<Array>} Array of leave records
 */
export const getCompanyLeaves = async () => {
  try {
    const endpoint = ENDPOINTS && ENDPOINTS.GET_COMPANY_LEAVES ? ENDPOINTS.GET_COMPANY_LEAVES : 'leaves/company';
    const url = `${BASE_URL}${endpoint}`;
    // prefer the current key used by AuthContext, fall back to legacy 'token'
    const token = localStorage.getItem('accessToken') || localStorage.getItem('token');

    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) headers.Authorization = `Bearer ${token}`;

    const response = await axios.get(url, { headers });

    return response.data ?? [];
  } catch (error) {
    if (error.response?.status === 404) return [];
    const message = error.response?.data?.error || error.message || 'Failed to fetch company leaves';
    throw new Error(message);
  }
};

export default {
  getCompanyLeaves
};
